<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useUserProfileStore } from '@stores/useUserProfileStore.ts';
import { type Component, computed } from 'vue';
import { AccountProfile } from '@enums/accountProfile.ts';
import MobileBuyerMenu from '@layout/nav-v2/mobile/components/menus/MobileBuyerMenu.vue';
import MobileSellerMenu from '@layout/nav-v2/mobile/components/menus/MobileSellerMenu.vue';
import MenuList from '@layout/nav-v2/mobile/components/MenuList.vue';
import IconList from '@icons/ph_list.svg';
import Typography from '@components/Typography.vue';
import Icon from '@components/Icon.vue';
import Button from '@components/Button.vue';
import { trans } from '@elements/translation.ts';
import { useNavbarStore } from '@stores/layout/useNavbarStore';
import MobileAnonymousMenu from '@layout/nav-v2/mobile/components/menus/MobileAnonymousMenu.vue';

const { userProfile, currentProfile } = storeToRefs(useUserProfileStore());

const navbarStore = useNavbarStore();
const { isPlusMenuOpen } = storeToRefs(navbarStore);
const { togglePlusMenu } = navbarStore;

const menu = computed<Component>(() => {
  if (userProfile.value === AccountProfile.ANONYMOUS) {
    return MobileAnonymousMenu;
  }

  if (userProfile.value === AccountProfile.UNQUALIFIED) {
    return MobileBuyerMenu;
  }

  if (userProfile.value === AccountProfile.BOTH) {
    return currentProfile.value === AccountProfile.SELLER ? MobileSellerMenu : MobileBuyerMenu;
  }

  if (userProfile.value === AccountProfile.SELLER) {
    return MobileSellerMenu;
  }

  return MobileBuyerMenu;
});
</script>

<template>
  <MenuList class="flex justify-around items-center">
    <component :is="menu" />

    <li>
      <Button
        :class="[
          '!border-0',
          '!w-[74px] !h-[44px]',
          '!p-0',
          'hover:bg-transparent'
        ]"
        @click="togglePlusMenu"
      >
        <Icon
          :svg="IconList"
          width="24"
          height="24"
          :fill="isPlusMenuOpen ? 'blue' : 'gray-darker'"
        />

        <Typography
          :class="{ '!font-semibold': isPlusMenuOpen }"
          variant="caption"
          :color="isPlusMenuOpen ? 'blue' : 'gray-darker'"
        >
          {{ trans('user_menu.plus') }}
        </Typography>
      </Button>
    </li>
  </MenuList>
</template>
